import { fetchApi } from '@/config/axiosSetting';
import { GetAdjusterRankpositionQueryResponseType } from './getAdjusterRankpositionQuery.type';

export const getAdjusterRankpositionFunction =
  (): Promise<GetAdjusterRankpositionQueryResponseType> => {
    return fetchApi.get('/survey/rank_position/');
  };
